
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BScMathematicsCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Sc. Mathematics",
    shortName: "B.Sc. Mathematics",
    duration: "3 years",
    description: "Bachelor's degree program focused on pure and applied mathematics, statistics, and computational methods",
    overview: "Bachelor of Science in Mathematics (B.Sc. Mathematics) is a 3-year undergraduate program that provides comprehensive study of pure mathematics, applied mathematics, statistics, and computational methods. This course covers calculus, algebra, geometry, differential equations, probability, and mathematical modeling, preparing students for careers in research, education, finance, and technology.",
    eligibility: [
      "10+2 with Mathematics as main subject",
      "Minimum 60% marks in Mathematics",
      "Physics and Chemistry as additional subjects",
      "Strong analytical and logical thinking skills"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Calculus and Analytical Geometry",
          "Algebra",
          "Trigonometry",
          "Statistics",
          "Physics",
          "Computer Programming"
        ]
      },
      {
        year: 2,
        subjects: [
          "Real Analysis",
          "Linear Algebra",
          "Differential Equations",
          "Probability Theory",
          "Numerical Methods",
          "Mathematical Software"
        ]
      },
      {
        year: 3,
        subjects: [
          "Complex Analysis",
          "Operations Research",
          "Mathematical Modeling",
          "Graph Theory",
          "Project Work",
          "Internship"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Data Scientist",
        "Statistician",
        "Research Analyst",
        "Actuarial Analyst",
        "Mathematics Teacher",
        "Software Developer",
        "Financial Analyst",
        "Operations Research Analyst",
        "Quality Analyst",
        "Cryptographer"
      ],
      industries: [
        "Information Technology",
        "Banking and Finance",
        "Insurance Companies",
        "Research Institutions",
        "Education Sector",
        "Government Organizations",
        "Consulting Firms",
        "Healthcare Analytics",
        "E-commerce",
        "Defense Organizations"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-35 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Google, Microsoft, Amazon",
        "SBI, HDFC, ICICI",
        "Deloitte, PwC",
        "Research Institutions",
        "Government Departments"
      ]
    },
    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "Cut-off based on Mathematics scores",
      "Online application process",
      "Counselling rounds"
    ],
    topColleges: [
      {
        name: "St. Stephen's College",
        location: "Delhi",
        fees: "₹45,000",
        ranking: "NIRF Ranking: 2"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "St. Xavier's College",
        location: "Mumbai",
        fees: "₹35,000",
        ranking: "Autonomous College"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1,50,000",
        ranking: "Deemed University"
      }
    ],
    skills: [
      "Mathematical Analysis",
      "Statistical Modeling",
      "Problem Solving",
      "Programming Skills",
      "Data Analysis",
      "Logical Reasoning",
      "Research Methods",
      "Mathematical Software",
      "Quantitative Analysis",
      "Abstract Thinking"
    ],
    futureScope: "Exceptional growth prospects with increasing demand for data scientists, AI/ML specialists, quantitative analysts, and mathematical modeling in various industries.",
    faqs: [
      {
        question: "What career opportunities exist after B.Sc. Mathematics?",
        answer: "Career options include data science, software development, banking, teaching, research, actuarial science, and further studies like M.Sc. Mathematics or MCA."
      },
      {
        question: "Can I work in IT companies with Mathematics degree?",
        answer: "Yes, mathematics graduates are highly valued in IT for roles in data science, analytics, algorithm development, and software engineering."
      },
      {
        question: "Is this course suitable for banking careers?",
        answer: "Yes, strong mathematical background is excellent for banking, especially in risk analysis, quantitative finance, and actuarial roles."
      },
      {
        question: "Can I pursue teaching after B.Sc. Mathematics?",
        answer: "Yes, you can become a mathematics teacher after B.Ed., or pursue M.Sc. and NET/SET for college-level teaching positions."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BScMathematicsCoursePage;
